export default function(data) {
  var self = this;

  self.$el = $('#admin_user_edit');
  self.$edit_role_modal = $('#edit_role_modal');
  self.$role_select = $('#course_role');

  self.new_email = ko.observable();
  self.editMode = ko.observable(true);
  self.editingName = ko.observable(false);
  self.enrollments = ko.observableArray();
  self.user = ko.observable();
  self.external_id = ko.observable();
  self.selected_enrollment = ko.observable();
  self.selected_role = ko.observable();
  self.enableProfile = ko.observable(false);

  self.resetSelected = function() {
    self.selected_enrollment(null);
    self.selected_role(null);
  };
  /*----------------------------------------USER STATE MANAGEMENT FUNCTIONS-------------------------------------*/
  self.selectRole = function(item, event) {
    self.selected_enrollment(item);
    self.selected_role(item.role());
    self.$edit_role_modal.modal('show');
  };

  self.getRoleName = function(item) {
    return (item.enrollment_type().toLowerCase() != item.role()) ? item.role().replace('_', ' ').capitalize_all() : item.enrollment_type();
  };

  self.changeRole = function() {
    self.$edit_role_modal.modal('hide');
    var url = Kadenze.Routes.change_role_admin_user_path(self.selected_enrollment().user_id());
    var method = 'PATCH';
    var data = {role: self.selected_role(), enrollment_id: self.selected_enrollment().id()};

    Kadenze.UIUtil.makeRequest(url, method, data, self.$el, null, function(data, textStatus, xhr) {
      Kadenze.UIUtil.showNotice($('#notice_container'), data, 5000);
      self.selected_enrollment().role(self.selected_role());
      self.resetSelected();
    }, function(xhr, textStatus, errorThrown) {
      Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 5000);
    }, function(xhr, textStatus) {
      $('.modal').modal('hide');
    });
  };

  self.removeEnrollment = function(item, event) {
    var url = Kadenze.Routes.remove_user_admin_course_path(item.enrollable_id(), {user_id: item.user_id()});
    var method = 'DELETE';
    var deletePrompt = 'Are you sure you want to remove the user from this course?';

    Kadenze.UIUtil.confirmAction(deletePrompt, function() {
      Kadenze.UIUtil.makeRequest(url, method, null, self.$el, null, function(data, textStatus, xhr) {
        self.enrollments.remove(item);
        Kadenze.UIUtil.showNotice($('#notice_container'), data, 3000);
      }, function(xhr, textStatus, errorThrown) {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
      });
    });
  };

  self.resetPassword = function() {
    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.reset_password_admin_user_path(self.user().id()),
      method: 'POST',
      loadingIndicator: {
        container: self.$el
      }
    });

    request.always(function() { $('#reset_password_modal').modal('hide'); });
    request.done(function(response, status, xhr) {
      new Kadenze.Notice.success({message: response.message});
    });
    request.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
        new Kadenze.Notice.error({message: msg});
      }
    });
  };

  self.changeEmail = function() {
    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.admin_user_path(self.user().id()),
      method: 'PATCH',
      data: { 'user': { 'email': self.new_email() } },
      loadingIndicator: {
        container: self.$el
      }
    });

    request.always(function() { $('#change_email_modal').modal('hide'); });
    request.done(function(response, status, xhr) {
      new Kadenze.Notice.success({message: response.message});
      self.user().email(self.new_email());
    });
    request.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
        new Kadenze.Notice.error({message: msg});
      }
    });
  };

  self.deleteAccount = function() {
    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.admin_user_path(self.user().id()),
      method: 'DELETE',
      loadingIndicator: {
        container: self.$el
      }
    });

    request.always(function() { $('#deactivate_delete_modal').modal('hide'); });
    request.done(function(response, status, xhr) {
      new Kadenze.Notice.success({message: response.message});
      Kadenze.Request.pjax({
        url: Kadenze.Routes.admin_users_path(),
        container: $('#main-pjax-container')
      });
    });
    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: xhr.responseJSON.message});
    });
  };

  self.saveExternalId = function() {
    self.user().external_id(self.external_id());
    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.admin_user_path(self.user().id()),
      method: 'PATCH',
      data: {user: {external_id: self.external_id()}},
      loadingIndicator: {
        container: self.$el
      }
    });
  };

  self.toggleProfile = function() {
    var data = {is_enable: !self.enableProfile()};
    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: "/admin/users/"+ self.user().id() +"/profile_access",
      data: data,
      loadingIndicator: true
    });

    request.done(function(response){
      new Kadenze.Notice.success({message: response.message});
      self.bindData(JSON.parse(response.data));
    });
  };
  
  self.external_id.subscribe(self.saveExternalId);

  self.bindData = function(data) {
    var mapped_user = ko.mapping.fromJS(data.user);
    var mapped_enrollments = ko.mapping.fromJS(data.enrollments);
    self.user(mapped_user);
    self.external_id(self.user().external_id());
    self.enableProfile(self.user().enable_profile());
    self.enrollments(mapped_enrollments());
  };

  self.full_name = ko.pureComputed({
    read: function() {
      if (self.user()) {
        return _.compact([self.user().first_name(), self.user().last_name()]).join(' ')
      } else {
        return ''
      }
    },
    write: function(val) {
      const parts = _.compact(val.split(/\s+/))
      self.user().first_name(parts[0] || '')
      self.user().last_name(parts.splice(1).join(' '))
    }
  });

  self.editMode.subscribe(self.editToggle);

  self.toggleEditProfile = function () {
    self.editMode(!self.editMode());
  };

  self.saveName = function() {
    const data = {
      user: {
        first_name: self.user().first_name(),
        last_name: self.user().last_name()
      }
    };

    self.client_errors = ko.validation.group([self.full_name, self.user().first_name, self.user().last_name]);

    if (self.client_errors().length) {
      self.client_errors.showAllMessages();
    } else {
      self.save(data)
      self.editingName(false)
    }
  };

  self.full_name.extend({fullName: true});

  self.editToggle = function(newVal) {
    if (!newVal) {
      if (self.editingName())
        self.saveName()
    }
  };

  self.editName = function() {
    self.editingName(true);
  };

  self.save = function (data) {
    const request = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: Kadenze.Routes.admin_user_path(self.user().id()),
      data: data,
      loadingIndicator: true
    });

    request.done(function(msg){
      msg = msg.message;
      new Kadenze.Notice.success({message: msg});
    });

    request.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
        new Kadenze.Notice.error({message: msg});
      }
    });

    return request;
  };

  const __construct = function(that) {
    console.log('constructor called for AdminUserEditorViewModel');
    that.bindData(data);
  }(this);
}
